// Simple countdown logic for the cart drawer
document.addEventListener('DOMContentLoaded', function() {
  // Initialize countdown on page load
  initSimpleCountdown();
  
  // Listen for cart drawer opening
  document.addEventListener('cart:opened', function() {
    setTimeout(initSimpleCountdown, 300);
  });
  
  // Watch for body class changes to detect cart drawer opening
  const bodyObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'class' && document.body.classList.contains('cart-sidebar-show')) {
        setTimeout(initSimpleCountdown, 300);
      }
    });
  });
  
  bodyObserver.observe(document.body, { attributes: true });
  
  // Also check periodically if the cart is open but countdown isn't running
  setInterval(function() {
    if (document.body.classList.contains('cart-sidebar-show')) {
      const timeElement = document.querySelector('.halo-cart-sidebar .cart-countdown .time');
      if (timeElement && !timeElement.hasAttribute('data-countdown-running')) {
        initSimpleCountdown();
      }
    }
  }, 3000);
});

function initSimpleCountdown() {
  // Check if cart is empty before showing countdown
  const cartItems = document.querySelectorAll('.previewCartItem');
  if (cartItems.length === 0) {
    // Hide existing countdown if cart is empty
    const existingCountdown = document.querySelector('.halo-cart-sidebar .cart-countdown');
    if (existingCountdown) {
      existingCountdown.style.display = 'none';
    }
    return;
  }
  
  // Find or create the countdown element
  let countdownContainer = document.querySelector('.halo-cart-sidebar .cart-countdown');
  
  if (!countdownContainer) {
    // Find the cart container
    const cartContainer = document.querySelector('.halo-cart-sidebar .previewCart-wrapper') || 
                          document.querySelector('.halo-cart-sidebar .previewCart');
    
    if (!cartContainer) return;
    
    // Create the countdown element
    countdownContainer = document.createElement('div');
    countdownContainer.className = 'cart-countdown alertBox alertBox--info d-flex flex-align-center flex-jc-center';
    countdownContainer.id = 'CartCountdown-sidecart';
    countdownContainer.style.marginBottom = '16px';
    
    // Create the inner HTML
    countdownContainer.innerHTML = `
      <div class="text alertBox-message">
        <div class="text-wrap d-inline-block">Votre panier et vos articles ont été réservés pour <span class="time d-inline-block" style="font-weight: bold;">09:59</span> minutes</div>
      </div>
    `;
    
    // Insert at the beginning of the cart content
    const firstChild = cartContainer.firstChild;
    if (firstChild) {
      cartContainer.insertBefore(countdownContainer, firstChild);
    } else {
      cartContainer.appendChild(countdownContainer);
    }
  } else {
    // Show countdown if it was hidden
    countdownContainer.style.display = 'block';
  }
  
  // Get the time element
  const timeElement = countdownContainer.querySelector('.time');
  if (!timeElement) return;
  
  // Stop any existing countdown
  if (timeElement.hasAttribute('data-countdown-id')) {
    clearInterval(parseInt(timeElement.getAttribute('data-countdown-id')));
  }
  
  // Set initial time (9:59)
  let minutes = 9;
  let seconds = 59;
  timeElement.textContent = `0${minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
  
  // Start the countdown
  const countdownId = setInterval(function() {
    // Decrement seconds
    seconds--;
    
    // Handle minute change
    if (seconds < 0) {
      seconds = 59;
      minutes--;
    }
    
    // Update the display
    timeElement.textContent = `0${minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
    
    // Check if countdown is complete
    if (minutes <= 0 && seconds <= 0) {
      // Reset the timer
      clearInterval(countdownId);
      
      // Show message about reservation deadline
      const messageElement = countdownContainer.querySelector('.text-wrap');
      if (messageElement) {
        const originalHTML = messageElement.innerHTML;
        messageElement.innerHTML = "Le délai de réservation est terminé. Votre panier a été réservé pour un nouveau délai.";
        
        // Restore original message and restart countdown after 5 seconds
        setTimeout(function() {
          messageElement.innerHTML = originalHTML;
          initSimpleCountdown(); // Restart countdown
        }, 5000);
      }
    }
  }, 1000);
  
  // Store the interval ID on the element for later cleanup
  timeElement.setAttribute('data-countdown-id', countdownId.toString());
  timeElement.setAttribute('data-countdown-running', 'true');
  timeElement.setAttribute('data-countdown-start', Date.now().toString());
} 